import TailwindProseWrapper from "~/components/TailwindProseWrapper"

import CarouselGallery from "./Carousel"
import TilesGallery from "./Tiles"
import type { ImageGalleryComponent } from "./types"

const ImageGallery: ImageGalleryComponent = ({ slice }) => {
  const component =
    slice.primary.display_type === "tiles" ? (
      <TilesGallery slice={slice} />
    ) : (
      <CarouselGallery slice={slice} />
    )

  return (
    <TailwindProseWrapper className="max-w-screen-lg">
      {component}
    </TailwindProseWrapper>
  )
}

export default ImageGallery
